var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('h4',{staticClass:"h4"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.strings),function(string,index){return _c('div',{key:index},[_c('div',[_vm._v(_vm._s(string))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }